import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import Media from 'sb-media'
import { mixpanel, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Product from 'components/product/Product/Product'
import { Button, buttonMessages } from 'components/_new/controls'

import messages from './messages'
import s from './RecommendationTagModal.scss'


class RecommendationTagModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      placement: PropTypes.string.isRequired, // addTo: queue or cart
    }),
    isMale: PropTypes.bool,
    recommendations: PropTypes.shape({
      items: PropTypes.array,
      tag: PropTypes.object,
    }),
  }

  static defaultProps = {
    name: constants.modals.RecommendationTag,
  }

  componentDidMount() {
    const { data: { placement } } = this.props

    mixpanel.track(constants.analyticsEvents.recommendationPopup[placement])
  }

  handleClick = () => {
    const { data: { placement } } = this.props

    mixpanel.track(constants.analyticsEvents.addTo[placement], { placement: 'recommendation popup queue' })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
    actions.models.recommendationTag.clear()
  }

  render() {
    const { name, isMale, data: { placement }, recommendations: { items, tag: { name: tag, image } } } = this.props

    const metadata          = { placement: 'recommendation popup queue' }
    const snowplowMetadata  = { placement: 'recommendation tag modal' } // TODO SNOWPLOW check if correct

    return (
      <Modal
        className={s.modal}
        name={name}
        title={messages.title}
        onClose={this.close}
      >
        <div className={s.tag}>
          <img className={s.image} src={image} alt="" />
          <FormattedHTMLMessage className={s.tagText} tag="div" {...messages.tagText} values={{ isMale, tag }} />
        </div>
        <FormattedHTMLMessage className={s.text} tag="div" {...messages.text} />
        <div className={s.items}>
          {
            items.map((item) => (
              <div key={item.id} className={s.item} onClick={this.close}>
                <Product
                  data={item}
                  addTo={placement}
                  onButtonClick={this.handleClick}
                  isHoverEffect={false}
                  isQuickViewVisible={false}
                  metadata={metadata}
                  snowplowMetadata={snowplowMetadata}
                />
              </div>
            ))
          }
        </div>
        <Media mobile>
          <Button
            className={s.button}
            title={buttonMessages.close}
            color="brand"
            size="md"
            fullWidth
            dataTestId="closeButton"
            onClick={this.close}
          />
        </Media>
      </Modal>
    )
  }
}


export default connect({
  isMale: (state) => state.models.me.gender === 'male',
  recommendations: 'models.recommendationTag',
})(RecommendationTagModal)
